import { Directive, inject, Renderer2, TemplateRef, ViewContainerRef, input } from '@angular/core';

import { EmailMailgunIfComponent } from './email-mailgun-if.component';
import type { WrappedValue } from '../mailgun/wrap-value';
import { TemplateRendererConfig } from '../providers/template-renderer-config';

@Directive({
  selector: '[mailgunIf]',
  standalone: true,
})
export class EmailMailgunIfDirective {
  public readonly config = inject(TemplateRendererConfig);
  public readonly renderer = inject(Renderer2);
  public readonly vcRef = inject(ViewContainerRef);
  public readonly oKTemplate = inject(TemplateRef<any>);

  public readonly elseTemplate = input<TemplateRef<unknown>>(undefined, { alias: 'mailgunIfElse' });
  public readonly variable = input<WrappedValue<any>>(undefined, { alias: 'mailgunIf' });

  private component = this.vcRef.createComponent(EmailMailgunIfComponent);

  public ngOnChanges() {
    this.displayTemplate();
  }

  private displayTemplate() {
    this.vcRef.clear();

    if (this.config.interpolate) {
      this.applyInterpolateMode();
    } else {
      this.applyMailgunMode();
    }
  }

  private applyInterpolateMode() {
    this.vcRef.createEmbeddedView(this.component.instance.interpolateIf, this.getContext());
  }

  private applyMailgunMode() {
    this.vcRef.createEmbeddedView(this.component.instance.mailgunIf, this.getContext());
  }

  private getContext() {
    return {
      prop: this.variable(),
      ok: this.oKTemplate,
      notOk: this.elseTemplate(),
    };
  }
}
